import { Injectable, OnInit, Output, EventEmitter } from '@angular/core';
import { Http, Response, Headers, URLSearchParams, Jsonp} from '@angular/http';
import { Subject, Subscription } from 'rxjs/Rx';
import {AuthService} from "./auth.service";
import { LoaderService } from '../common/loadingBar/loader.service';
import { Router } from "@angular/router";



@Injectable()
export class UsersService extends AuthService{

    //private subject = new Subject<string>();
    private URLSearchUser = "manager/user/search";
    private URLUserByPhone = "manager/user/:term/predict-phone";
    private URLUserByName = "manager/user/:term/predict-name";
    private URLUserByFullName = "manager/user/:term/predict-fullname";
    private URLUserBySurname = "manager/user/:term/predict-surname";
    private URLGetUserAddress = "manager/user/:id/address";
    private URLGetUserById = "manager/user/:id"
    private URLUserByEmail = "manager/user/:term/predict-email";
    private URLUserByContactName = "api/v1/findUserPersonContactName/:term";
    private URLUserByCif = "api/v1/findUserByCIF/:cif";
    private URLCheckUserExists = "api/v1/checkIfUserExists/:cif";
    private KEY = ":term";
    private ID = ":id";
    private CIF = ":cif";

    constructor(public http: Http, public router: Router, private loaderService: LoaderService) {
        super(http,router);
    }

    public getUserById(id: string) {
        let URLGetUserById = this.URLGetUserById.replace(this.ID, id);
        return this.http.get(this.APIURL + URLGetUserById ,{headers: this.headers})
        .map((res: Response) => res.json()["response"]);
    }

    public findUserByName(name: string) {

        let URLUserByName = this.URLUserByName.replace(this.KEY, name);
        return this.http.get(this.APIURL + URLUserByName ,{headers: this.headers})
        .map((res: Response) => res.json()["response"]);
    }

    public findUserByFullName(fullname: string) {
        
        let URLUserByFullName = this.URLUserByFullName.replace(this.KEY, fullname);
        return this.http.get(this.APIURL + URLUserByFullName ,{headers: this.headers})
        .map((res: Response) => res.json()["response"]);
    }


    public findUserByPhone(phone: string) {
        
        let URLUserByPhone = this.URLUserByPhone.replace(this.KEY, phone);
        return this.http.get(this.APIURL + URLUserByPhone ,{headers: this.headers})
        .map((res: Response) => res.json()["response"]);
    }

    public findUserBySurname(surname: string) {
        let URLUserBySurname = this.URLUserBySurname.replace(this.KEY, surname);
        return this.http.get(this.APIURL + URLUserBySurname ,{headers: this.headers})
        .map((res: Response) => {
            return res.json()["response"];
        });
    }

    public findUserByEmail(email: string) {
        //this.loaderService.show();
        let URLUserByEmail = this.URLUserByEmail.replace(this.KEY, email);
        return this.http.get(this.APIURL + URLUserByEmail ,{headers: this.headers})
        .map((res: Response) => {
            //this.loaderService.hide();
            return res.json()["response"]
        });
    }

    public getUserAddress(id: string) {
        
        let URLGetUserAddress = this.URLGetUserAddress.replace(this.ID, id);
        return this.http.get(this.APIURL + URLGetUserAddress ,{headers: this.headers})
        .map((res: Response) => res.json()["response"]);
    }

     public findUserByCif(cif: string) {
        let URLUserByCif = this.URLUserByCif.replace(this.CIF, cif);
        return this.http.get(this.APIURL + URLUserByCif ,{headers: this.headers})
        .map((res: Response) => res.json()["data"]);
    }

    public checkIfUserExits(cif: string) {
        let URLCheckUserExists = this.URLCheckUserExists.replace(this.CIF, cif);
        return this.http.get(this.APIURL + URLCheckUserExists ,{headers: this.headers})
        .map((res: Response) => res.json()["status"]);
    }
}


// WEBPACK FOOTER //
// ./src/app/injections/users.service.ts